import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Stack, Typography, Switch, FormControlLabel, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { includesIndustryLibrary } from '../utils/libraryPrefs';

/**
 * Settings → Organization → Learning Library (Tim, Aug 25 chat): include or exclude the
 * industry library (CSB case studies and documents other organizations shared).
 * Hiding it only hides content — the organization's own numbers are untouched and
 * REPSit keeps what it has already learned from those cases.
 */
export function LearningLibrarySection({ organization, saving, onSave }) {
  const on = includesIndustryLibrary(organization);
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <AutoStoriesIcon color="primary" />
          <Typography variant="h6">Learning Library</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <FormControlLabel
          control={<Switch checked={on} disabled={saving} onChange={(e) => onSave({ includeIndustryLibrary: e.target.checked })} inputProps={{ 'aria-label': 'Show industry case studies in our Learning Library' }} />}
          label={<Box><Typography variant="body1">Show industry case studies in our Learning Library</Typography><Typography variant="body2" color="text.secondary">CSB case studies and documents other organizations have shared with the REPSit Common Database.</Typography></Box>}
          sx={{ alignItems: 'flex-start', ml: 0 }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
          Turning this off hides the industry content from your library, search, the OE Dashboard case-study widget, alert references and the benchmark picker. Your scores, trends and warnings come only from your own surveys and OE Conditions and are not affected — and what REPSit has already learned from those cases keeps working on your data.
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
